// extracted by mini-css-extract-plugin
export default {"reporting":"reporting-module__reporting____fakK","reporting__body":"reporting-module__reporting__body___leIxt"};